import Vue from "vue";
import Router from "vue-router";
import TheAdminLayout from "@/Pages/Admin/Includes/TheLayOut.vue";
import AuthRoute from "@/Pages/Admin/Modules/Auth/Routes/AuthRoute";
import Dashboard from "@/Pages/Admin/Modules/Admin/Controllers/Dashboard";
// import AccountDashboard from '@/Pages/Admin/Modules/Admin/Controllers/AccountDashboard';
import TrekRoute from "@/Pages/Admin/Modules/ManagePackage/tab/Routes/index";
import ProfileRoute from "@/Pages/Admin/Modules/ManageUsers/Profile/Routes/index";
import GeneralModuleRoute from "@/Pages/Admin/Modules/ManagePackage/tab/General/Routes/index";
import ManageDeparture from "@/Pages/Admin/Modules/ManageDeparture/Controllers/ManageDeparture";
import AddDeparture from "@/Pages/Admin/Modules/ManageDeparture/Controllers/AddDeparture";
import EditDeparture from "@/Pages/Admin/Modules/ManageDeparture/Controllers/EditDeparture";
import DetailDeparture from "@/Pages/Admin/Modules/ManageDeparture/Controllers/DetailDeparture";
import ManageDeparturePackage from "@/Pages/Admin/Modules/ManageDeparture/Controllers/ManageDeparturePackage";
import ManageUsers from "@/Pages/Admin/Modules/ManageUsers/Controllers/ManageUsers";
import ManageBooking from "@/Pages/Admin/Modules/ManageBooking/Controllers/ManageBooking";
// import Profile from '@/Pages/Admin/Modules/ManageUsers/Profile/Controllers/Profile';
//hotel
import HotelRoute from "@/Pages/Admin/Modules/Hotel/Routes/HotelRoute";
import GeneralHotelModelRoute from "@/Pages/Admin/Modules/Hotel/tab/routes/index";

import AboutProfile from "@/Pages/Admin/Modules/ManageUsers/Profile/About/Controllers/AboutProfile";
import SocialAccount from "@/Pages/Admin/Modules/ManageUsers/Profile/SocialAccounts/Controllers/SocialAccount";
import Contact from "@/Pages/Admin/Modules/ManageUsers/Profile/Contacts/Controllers/Contact";
import BannerImage from "@/Pages/Admin/Modules/ManageUsers/Profile/BannerImage/Controllers/BannerImage";
import OfficeDay from "@/Pages/Admin/Modules/ManageUsers/Profile/OfficeDays/Controllers/OfficeDay";
import ChangePassword from "@/Pages/Admin/Modules/ManageUsers/ChangePassword/Controllers/ChangePassword";

import Invite from "@/Pages/Admin/Modules/ManageUsers/Invite/Controllers/Invite";
import PendingList from "@/Pages/Admin/Modules/ManageUsers/PendingInvite/Controllers/PendingInvite";
import ViewDetails from "@/Pages/Admin/Modules/ManageBooking/ViewDetails/Controllers/ViewDetails";

import CompanyProfile from '@/Pages/Admin/Modules/ManageUsers/Profile/Controllers/Profile';
import IndividualProfile from "@/Pages/Admin/Modules/ManageUsers/Profile/Controllers/IndividualProfile";
import ManageAccountRequest from "@/Pages/Admin/Modules/ManageAccountRequest/Controllers/ManageAccountRequest";
import ManageAccount from "@/Pages/Admin/Modules/ManageAccount/Controllers/ManageAccount";
import Setting from "@/Pages/Admin/Modules/Settings/Controllers/Setting";
import ManageBlog from "@/Pages/Admin/Modules/Blog/Controllers/ManageBlog";
import Subscription from "@/Pages/Admin/Modules/Subscription/Controllers/Subscription";
import Invoice from "@/Pages/Admin/Modules/Invoices/Controllers/Invoices.ts";
import InvoicesDetails from "@/Pages/Admin/Modules/Invoices/Controllers/InvoiceDetails";
import Authorization from "@/Pages/Admin/Modules/Auth/Controllers/Authorization";

import { common } from "@/Pages/Admin/Modules/Common/Services/Common";

Vue.use(Router);
const baseRoutes: any[] = [
  {
    path: "/",

    title: "AdminLayout",
    component: TheAdminLayout,
    redirect: { name: "business-dashboard" },
    children: [
      {
        path: "dashboard",
        name: "business-dashboard",
        component: Dashboard
      },
      // {
      //     path: 'account',
      //     name: 'account-dashboard',
      //     component: AccountDashboard,
      // },
      {
        path: "departure",
        name: "business-manage-departure-trek-list",
        component: ManageDeparture,
      },
      {
        path: "departure/add",
        name: "business-manage-departure-add",
        component: AddDeparture,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "departure/detail",
        name: "business-manage-departure-detail",
        component: DetailDeparture,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "departure/edit",
        name: "business-manage-departure-edit",
        component: EditDeparture
      },
      {
        path: "booking",
        name: "business-manage-booking",
        component: ManageBooking,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      // {
      //     path: 'booking',
      //     name: 'business-manage-booking',
      //     component: ManageBooking,
      // },
      {
        path: "booking/viewdetails",
        name: "business-manage-booking-view-details",
        component: ViewDetails,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "myprofile",
        name: "business-dashboard-manage-individualProfile",
        component: IndividualProfile
      },
      {
        path: "profile",
        name: "business-dashboard-manage-profile-tab",
        component: CompanyProfile,
        redirect: { name: "business-dashboard-manage-profile-tab-about" },
        children: [
          {
            path: "about",
            name: "business-dashboard-manage-profile-tab-about",
            component: AboutProfile
          },
          {
            path: "socialaccount",
            name: "business-dashboard-manage-profile-tab-social-account",
            component: SocialAccount
          },
          {
            path: "contact",
            name: "business-dashboard-manage-profile-tab-contact",
            component: Contact
          },
          {
            path: "image",
            name: "business-dashboard-manage-profile-tab-banner-image",
            component: BannerImage
          },
          {
            path: "officehour",
            name: "business-dashboard-manage-profile-tab-office",
            component: OfficeDay
          }
        ]
        // },
        // {
        //     path: '/',
        //     name: 'user-profile-tab',
        //     component: ProfileTab,
        //     redirect: { name: 'business-dashboard-manage-profile-tab' },
        //     children: [
        //         {
        //             path: 'profile',
        //             name: 'business-dashboard-manage-profile-tab',
        //             component: ProfileTab,
        //         },
        //     ],
      },
      {
        path: "unauthorised",
        name: "user-unauthorized",
        component: Authorization
      },
      // {
      //     path: 'profile/about',
      //     name: 'business-dashboard-manage-profile-tab-about',
      //     component: AboutProfile,
      // },

      // {
      //     path: 'profile/socialaccount',
      //     name: 'business-dashboard-manage-profile-tab-social-account',
      //     component: SocialAccount,
      // },

      // {
      //     path: 'profile/contact',
      //     name: 'business-dashboard-manage-profile-tab-contact',
      //     component: Contact,
      // },

      // {
      //     path: 'profile/image',
      //     name: 'business-dashboard-manage-profile-tab-banner-image',
      //     component: BannerImage,
      // },

      // {
      //     path: 'profile/officehour',
      //     name: 'business-dashboard-manage-profile-tab-office',
      //     component: OfficeDay,
      // },
      {
        path: "changepassword",
        name: "user-profile-change-password",
        component: ChangePassword
      },
      {
        path: "manage-users",
        name: "user-manage-dashboard",
        component: ManageUsers,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.CurrentLoggedBusinessUser();
          if (currentUser && currentUser.userRole === "operator") {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "account-request",
        name: "user-manage-account-request-dashboard",
        component: ManageAccountRequest
      },
      {
        path: "manage-account",
        name: "user-manage-account-dashboard",
        component: ManageAccount
      },
      {
        path: "manage-users/invite",
        name: "user-invite",
        component: Invite,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.CurrentLoggedBusinessUser();
          if (currentUser && currentUser.userRole === "operator") {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "manage-users/invitepending",
        name: "user-pending-invite",
        component: PendingList,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "manage-blog",
        name: "user-manage-blog",
        component: ManageBlog
      },
      {
        path: "invoices",
        name: "user-invoice",
        component: Invoice,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "invoices/detail",
        name: "user-manage-invoices-view",
        component: InvoicesDetails,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },

      {
        path: "settings",
        name: "user-all-settings",
        component: Setting,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      },
      {
        path: "subscription",
        name: "user-subscription",
        component: Subscription,
        beforeEnter(to: any, from: any, next: any) {
          const currentUser = common.isPermission();
          if (currentUser) {
            next();
          } else {
            // next("/dashboard");
            next({ name: "user-unauthorized" });
          }
        }
      }
    ]
  }
];
const routes = baseRoutes.concat(AuthRoute, TrekRoute, HotelRoute, GeneralModuleRoute ,GeneralHotelModelRoute);
export default new Router({
  // mode: 'history',
  routes
});
